import Cache from 'root/cache';
import Router from 'root/router';
import Modals from 'root/modals';
import UI from 'root/ui';
import Tooltip from 'root/module/tooltip';
import View from 'root/view/base';
import { syncOnboarding } from 'service/account';
import { isProjectPage } from 'root/page/base';
import confetti from 'canvas-confetti';

export default View.extend({
    className: 'code-install-banner',

    events: {
        'click .onboarding-get-code'             : 'onboardingGetCode',
        'click .onboarding-edit-widget'          : 'onboardingEditWidget',
        'click .onboarding-connect-integrations' : 'onboardingConnectIntegrations',
        'click .onboarding-setup-automation'     : 'onboardingSetupAutomation',
        'click .onboarding-edit-survey'          : 'onboardingEditSurvey',
        'click .onboarding-invite-user'          : 'onboardingInviteUser',
        'click .setup-dismiss'                   : 'onboardingDismiss'
    },

    dom_handlers: {
        onboardingGetCode: function(e) {
            Modals.getWidgetCode();
        },

        onboardingEditWidget: function(e) {
            if (isProjectPage(UI.current_page) && Cache.getDefaultProject().isFeedback()) {
                Modals.openWidgetStudio();
            } else {
                var first_feedback_project = Cache.project.findWhere({is_archived: false, project_type: 'feedback'});

                if (first_feedback_project) {
                    Router.navigate('/' + first_feedback_project.get('project_key') + '/dashboard/designer', {trigger: true});
                }
            }
        },

        onboardingEditSurvey: function(e) {
            if (isProjectPage(UI.current_page) && Cache.getDefaultProject().isSurvey()) {
                Modals.openSurveyStudio();
            } else {
                var first_survey_project = Cache.project.findWhere({is_archived: false, project_type: 'survey'});

                if (first_survey_project) {
                    Router.navigate('/' + first_survey_project.get('project_key') + '/dashboard/designer', {trigger: true});
                }
            }
        },

        onboardingInviteUser: function(e) {
            Modals.inviteUser();
        },

        onboardingConnectIntegrations: function(e) {
            Router.navigate('/' + Cache.project.findWhere({is_archived: false}).get('project_key') + '/integration/', {trigger: true});
        },

        onboardingSetupAutomation: function(e) {
            Modals.projectSettings(Cache.project.findWhere({is_archived: false}).id, 'automation', () => {
                Cache.app.trackProjectOnboarding('setup_automation', 1);
            });
        },

        onboardingDismiss: function(e) {
            Tooltip.removeAll();
            this.remove();

            Cache.app.addUserSetting('onboarding_checklist_dismissed', 1, false);
        },

        clearOnboardingInterval: function(e) {
            if (this.onboarding_interval) {
                clearInterval(this.onboarding_interval);
            }
        }
    },

    initialize: function() {
        this.listenTo(Cache.account, 'change:onboarding',         this.render);
        this.listenTo(Cache.account, 'change:project_onboarding', this.render);
        this.listenTo(Cache.project, 'add remove',                this.render);
        this.listenTo(Cache.project, 'change:is_archived',        this.render);

        this.listenTo(this, 'remove', this.dom_handlers.clearOnboardingInterval);

        Cache.app.dispatcher.on('onboarding_welcome_close', this.flash.bind(this));
    },

    flash: function() {
        this.$el.addClass('flash');
    },

    render: function() {
        if (Cache.app.getUserSetting('onboarding_checklist_dismissed', false)) {
            return this;
        }

        if (!Cache.app.isAdmin()) {
            return this;
        }

        this.is_first_render = this.is_first_render === undefined ? true : false;

        var is_account_installed = Cache.account.get('onboarding').widget_install == 1;
        var is_project_installed = Cache.project.some((project) => {
            return Cache.app.getProjectOnboarding('install_code', project.id) == 1;
        });
        var is_code_installed = is_account_installed || is_project_installed ? true : false;

        var content = '';

        var has_feedback_project = Cache.project.some((project) => {
            return project.isFeedback() && !project.get('is_archived');
        });

        var items = [{
            title: has_feedback_project ? 'Install your widget' : 'Install your survey',
            completed: is_code_installed,
            action_class: 'onboarding-get-code'
        }];

        if (has_feedback_project) {
            items.push({
                title: 'Customize your widget',
                completed: Cache.project.models.some((project) => {
                    return Cache.app.getProjectOnboarding('edit_widget', project.id) == 1;
                }),
                action_class: 'onboarding-edit-widget'
            });
        } else {
            items.push({
                title: 'Customize your survey',
                completed: Cache.project.models.some((project) => {
                    return Cache.app.getProjectOnboarding('edit_survey', project.id) == 1;
                }),
                action_class: 'onboarding-edit-survey'
            });
        }

        items.push({
            title: 'Connect Integrations',
            completed: Cache.account.get('onboarding').integration_connect == 1,
            action_class: 'onboarding-connect-integrations'
        });

        if (has_feedback_project) {
            items.push({
                title: 'Setup Automation',
                completed: Cache.project.models.some((project) => {
                    return Cache.app.getProjectOnboarding('setup_automation', project.id) == 1;
                }),
                action_class: 'onboarding-setup-automation'
            });
        }

        items.push({
            title: 'Invite Team Members',
            completed: Cache.account.get('onboarding').workspace_members_add == 1 || Cache.workspace_member.length > 1 || Cache.user_invitation.length > 0,
            action_class: 'onboarding-invite-user'
        });

        var completed_total = 0;
        items.forEach((item, index) => {
            if (item.completed) {
                completed_total++;
            }
        });

        clearInterval(this.onboarding_interval);

        if (completed_total === items.length && this.is_first_render) {
            // do not show
        } else {
            if (completed_total < items.length) {
                this.onboarding_interval = setInterval(() => {
                    syncOnboarding();
                }, 6000);
            }

            content = '' +
            '<button class="setup-dismiss tooltip" data-title="Dismiss"><i class="fa-regular fa-xmark"></i></button>' +
            '<div class="font-weight-semibold text-default text-shiny">Getting Started</div>' +
            '<ul>' +
                items.map((item) => {
                    return item.completed ?
                    '<li class="' + item.action_class + ' completed"><i class="fa-solid fa-check-circle fa-fw"></i>' + item.title + '</li>' :
                    '<li class="' + item.action_class + '"><i class="fa-regular fa-circle fa-fw"></i>' + item.title + '</li>';
                }).join('') +
            '</ul>' +
            '<div class="text-info text-align-right">' + completed_total + ' of ' + items.length + '</div>';

            if (!this.is_first_render && completed_total === items.length) {
                confetti({
                    particleCount: 100,
                    spread: 70,
                    origin: {
                        x: (this.$el.offset().left + this.$el.width() / 2) / window.innerWidth,
                        y: (this.$el.offset().top + this.$el.height() / 2) / window.innerHeight
                    }
                });

                setTimeout(() => {
                    this.remove();
                }, 3000);
            }
        }

        this.$el.html(content);

        this.is_first_render = false;

        return this;
    }
});